import { Injectable, inject } from '@angular/core';
import { ApiService } from '@core/services';
import { Parameter } from '../models';
import { Observable } from 'rxjs';
import { BussinesService } from '../../public/services/bussines.service';
import { GeneralResponse } from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class ParameterService {
  private apiService = inject(ApiService);

  getParameters(businessId?: number): Observable<GeneralResponse<Parameter[]>> {
    return this.apiService.get<Parameter[]>(
      `parameter?businessId=${businessId}`
    );
  }
  getParametersGeneral(): Observable<GeneralResponse<Parameter[]>> {
    return this.apiService.get<Parameter[]>(`parameter`);
  }

  getParameter(id: string, businessId?: number): Observable<Parameter> {
    const byId = `?businessId=${businessId}&name=${id}`;
    return this.apiService.getById('parameter', byId);
  }

  getParameterMail(): Observable<any> {
    return this.apiService.get('parameter/mailserver');
  }

  sendParameterMail(body: object): Observable<any> {
    return this.apiService.update('parameter/mailserver', body);
  }

  updateParameter(data: Parameter, id: number, businessId: string) {
    const body = {
      key: data.key,
      value: data.value,
      description: data.description,
      businessId: businessId,
    };
    return this.apiService.update(`parameter/${id}`, body, id);
  }
}
